<div class="menu-items">
    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-website-account'}" (click)="selectTeamMenu('team-website-account')">
        Team Website Account<span></span>
    </div>    
    <div class="menu-item" (click)="toggleDisplay()">
        Team Information<span></span>
        <span *ngIf="!submenu" class="dropdown-icon pi pi-fw pi-chevron-down"></span>
        <span *ngIf="submenu" class="dropdown-icon pi pi-fw pi-chevron-up"></span>
    </div>
  
    <div class="sub-menu" *ngIf="submenu">
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/team-website/team-information'}" (click)="selectTeamMenu('team-information')">
            Team Information<span></span>
        </div>
        <div class="menu-item web-display" [ngClass]="{'selected-menu': url === '/portal/team-website/team-contact-information'}" (click)="selectTeamMenu('team-contact-information')">
            Team Contact Information<span></span>
        </div>
        <div class="menu-item mob-display" [ngClass]="{'selected-menu': url === '/portal/team-website/team-information'}" (click)="selectTeamMenu('team-information')">
            Team Info<span></span>
        </div>
        <div class="menu-item mob-display" [ngClass]="{'selected-menu': url === '/portal/team-website/team-contact-information'}" (click)="selectTeamMenu('team-contact-information')">
            Team Contact Info<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-biography'}" (click)="selectTeamMenu('team-biography')">
            Team Biography<span></span>
        </div>
        
        <div class="menu-item " [ngClass]="{'selected-menu': url === '/portal/team-website/mls-ids'}" (click)="selectTeamMenu('mls-ids')">
            MLS ID's<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-designations'}" (click)="selectTeamMenu('team-designations')">
            Designations<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-specialties'}" (click)="selectTeamMenu('team-specialties')">
            Specialties<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-languages'}" (click)="selectTeamMenu('team-languages')">
            Languages<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-counties-cities-served'}" (click)="selectTeamMenu('team-counties-cities-served')">
            Counties & Cities Served<span></span>
        </div>
        <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-social-network'}" (click)="selectTeamMenu('team-social-network')">
            Social Network Affiliations<span></span>
        </div>
    </div>

    <div class="menu-item" [ngClass]="{'selected-menu': url === '/portal/team-website/team-website-listings'}" (click)="selectTeamMenu('team-website-listings')">
        Team Website & Listings<span></span>
    </div>

</div>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="selectMenuConfirmation()"
  #changeMenuModal
>
</app-search-update-confirmation>